// Frontend TypeScript entry point
import { initDropdowns } from './dropdown';
import { initAccordions } from './accordion';
import { initTabs } from './tabs';
import { initSwipers } from './swiper';
import { initFeaturedTips } from './featured-tip';
import { initVideos } from './video';
import { initFlyovers } from './flyover';
import { initSearchInputs } from './searchInput';
import { initCopyToClipboard } from './copyToClipBoard';
import { initOffCanvas } from './offCanvas';
import { initEmailForm } from './email-form';
import { initHotjar } from './hotjar';

document.addEventListener('DOMContentLoaded', () => {

    // Initialize dropdown menus
    initDropdowns();

    // Initialize accordions
    initAccordions();

    // Initialize tabs
    initTabs();

    // Initialize swipers
    initSwipers();

    // Initialize featured tip navigation
    initFeaturedTips();

    // Initialize video facades
    initVideos();

    // Initialize flyovers
    initFlyovers();

    // Initialize search input
    initSearchInputs();

    // Initialize copy to clipboard buttons
    initCopyToClipboard();

    // Init Off-canvas menus
    initOffCanvas();

    // Initialize email signup forms
    initEmailForm();

    // Initialize Hotjar survey triggers
    initHotjar();
});
